import { SortDirection } from '@/components/ui/table'
import { CustomerSortColumn } from '@/models/user'

// The way each column reads best first: names A–Z and statuses in funnel order, user
// counts and bound and start dates biggest or newest first, expiry soonest first.
const FIRST_DIRECTION: Record<CustomerSortColumn, SortDirection> = {
  [CustomerSortColumn.NAME]: SortDirection.ASCENDING,
  [CustomerSortColumn.STATUS]: SortDirection.ASCENDING,
  [CustomerSortColumn.USERS]: SortDirection.DESCENDING,
  [CustomerSortColumn.BOUND]: SortDirection.DESCENDING,
  [CustomerSortColumn.STARTS]: SortDirection.DESCENDING,
  [CustomerSortColumn.EXPIRES]: SortDirection.ASCENDING,
}

export interface CustomerSort {
  column: CustomerSortColumn
  direction: SortDirection
}

/** Read the list's sort param, e.g. "-bound"; null for the default order. */
export function parseCustomerSort(sort: string): CustomerSort | null {
  const column = Object.values(CustomerSortColumn).find((value) => value === sort.replace(/^-/, ''))
  if (!column) return null
  return { column, direction: sort.startsWith('-') ? SortDirection.DESCENDING : SortDirection.ASCENDING }
}

/** The sort param after clicking a column: its best-first way, then reversed, then the default order. */
export function nextCustomerSort(sort: string, column: CustomerSortColumn): string {
  const first = FIRST_DIRECTION[column]
  const current = parseCustomerSort(sort)
  if (current?.column !== column) return sortParam(column, first)
  if (current.direction !== first) return ''
  return sortParam(
    column,
    first === SortDirection.ASCENDING ? SortDirection.DESCENDING : SortDirection.ASCENDING
  )
}

function sortParam(column: CustomerSortColumn, direction: SortDirection): string {
  return direction === SortDirection.DESCENDING ? `-${column}` : column
}
